var exports = {
  "kL": "xa15a2ab7--e402dd--container",
  "cA": "xa15a2ab7--e402dd--link-with-icon",
  "X_": "xa15a2ab7--e402dd--target-link-icon",
  "DD": "xa15a2ab7--e402dd--title",
};

module.exports = exports;
